export default __webpack_public_path__ + "static/media/indent-decrease.d8836e46.svg";